import { useEventBus } from '@vueuse/core'

interface EventGlobalEventBus {
  sourceType: string
  sourceId: string
  eventType: string
  eventValue: any
}

const useGlobalEventBus = (): any => {

  const eventBus = useEventBus<EventGlobalEventBus>('global')

  return {
    eventBus
  }
}

export {
  EventGlobalEventBus,
  useGlobalEventBus
}
